export default __webpack_public_path__ + "static/media/farm-equipment.652057ac.svg";